import { Meal } from '@/models/meal'
import { isMealProgramSubscription } from './sakara'
import { MealProgramSubscription } from '@/models/meal-program-subscription'
import { MealProgramSubscriptionWeek } from '@/models/meal-program-subscription-week'
import { ProductSubscription } from '@/models/product-subscription'
import type {
  Campaign as PopsCampaign,
  Subscription as PopsSubscription,
  Meal as PopsMeal,
  PopsPackage,
} from '@/types/pops'
import { SakaraClassicMeal } from '@/models/sakara-classic-meal'
import { Campaign } from '@/models/campaign'
import { Package } from '@/models/package'

export const createSubscription = (rawSubscription: PopsSubscription) => {
  if (isMealProgramSubscription(rawSubscription)) {
    if (rawSubscription.week) {
      return new MealProgramSubscriptionWeek(rawSubscription)
    }

    return new MealProgramSubscription(rawSubscription)
  }

  return new ProductSubscription(rawSubscription)
}

export const createSubscriptions = (rawSubscriptions: PopsSubscription[]) => {
  return rawSubscriptions.map(createSubscription)
}

export const createPackages = (rawPackages: PopsPackage[]) => {
  return rawPackages.map((pack) => new Package(pack))
}

export const createCampaign = (rawCampaign: PopsCampaign) => {
  return new Campaign(rawCampaign) // TODO: implement
}

export const createMeal = (rawMeal: PopsMeal) => {
  if (rawMeal.classic_meal_property) {
    return new SakaraClassicMeal(rawMeal)
  }

  return new Meal(rawMeal)
}
